import { httpClient } from '@/core/api/httpClient';
import { toPascalCaseParams } from '@/shared/lib/to-pascal-case-params';
import { env } from '@/core/config/env';
import { API_V1 } from '@/core/api/endpoints';
import type {
  PerformanceSummary,
  MemberTimelineEntry,
  MemberTableEntry,
  ProjectPerformanceEntry,
  PerformanceFilters,
} from '../types';
import { mockSummary, mockTimeline, mockTable, mockProjects } from './laborPerformance.mock';

export const laborPerformanceService = {
  getSummary: (
    filters: Pick<PerformanceFilters, 'periodStart' | 'periodEnd'>,
    signal?: AbortSignal,
  ): Promise<PerformanceSummary> => {
    if (env.VITE_USE_MOCK === 'true') return Promise.resolve(mockSummary);
    return httpClient
      .get<PerformanceSummary>(`${API_V1}/performance/summary`, {
        params: toPascalCaseParams(filters as unknown as Record<string, unknown>),
        signal,
      })
      .then((res) => res.data);
  },

  getTimeline: (
    filters: PerformanceFilters,
    signal?: AbortSignal,
  ): Promise<MemberTimelineEntry[]> => {
    if (env.VITE_USE_MOCK === 'true') return Promise.resolve(mockTimeline);
    return httpClient
      .get<MemberTimelineEntry[]>(`${API_V1}/performance/timeline`, {
        params: toPascalCaseParams(filters as unknown as Record<string, unknown>),
        signal,
      })
      .then((res) => res.data);
  },

  getTable: (filters: PerformanceFilters, signal?: AbortSignal): Promise<MemberTableEntry[]> => {
    if (env.VITE_USE_MOCK === 'true') return Promise.resolve(mockTable);
    return httpClient
      .get<MemberTableEntry[]>(`${API_V1}/performance/table`, {
        params: toPascalCaseParams(filters as unknown as Record<string, unknown>),
        signal,
      })
      .then((res) => res.data);
  },

  getProjects: (
    filters: Pick<PerformanceFilters, 'periodStart' | 'periodEnd'>,
    signal?: AbortSignal,
  ): Promise<ProjectPerformanceEntry[]> => {
    if (env.VITE_USE_MOCK === 'true') return Promise.resolve(mockProjects);
    return httpClient
      .get<ProjectPerformanceEntry[]>(`${API_V1}/performance/projects`, {
        params: toPascalCaseParams(filters as unknown as Record<string, unknown>),
        signal,
      })
      .then((res) => res.data);
  },
};
